const accountSelector = 'shopify-account[data-gohall-account-url]';
const fallbackSelector = '[data-gohall-account-fallback]';
const fallbackClass = 'account-button--fallback';
const definitionTimeout = 1800;
const activationTimeout = 700;

const delay = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

const getWrapper = (account) => account.closest('.account-button');

const showFallback = (account) => {
  const wrapper = getWrapper(account);
  const fallback = wrapper?.querySelector(fallbackSelector);
  if (!(wrapper instanceof HTMLElement) || !(fallback instanceof HTMLAnchorElement)) return;

  wrapper.classList.add(fallbackClass);
  account.setAttribute('aria-hidden', 'true');
};

const nativeControlIsReady = (account) => {
  const { shadowRoot } = account;
  if (!shadowRoot) return false;

  return Boolean(shadowRoot.querySelector('button, a[href], [role="button"]'));
};

const nativeInterfaceIsOpen = (account) => {
  const { shadowRoot } = account;
  if (!shadowRoot) return false;

  if (shadowRoot.querySelector('dialog[open], details[open], [aria-expanded="true"]')) return true;

  return Array.from(shadowRoot.querySelectorAll('[popover]')).some((popover) => {
    try {
      return popover.matches(':popover-open');
    } catch {
      return false;
    }
  });
};

const verifyAccount = async (account) => {
  const wasDefined = Boolean(customElements.get('shopify-account'));
  const definitionResult = wasDefined
    ? true
    : await Promise.race([
        customElements.whenDefined('shopify-account').then(() => true),
        delay(definitionTimeout).then(() => false),
      ]);

  if (definitionResult) await delay(100);
  if (!definitionResult || !nativeControlIsReady(account)) showFallback(account);
};

const verifyAccounts = (root = document) => {
  if (!(root instanceof Document) && !(root instanceof Element)) return;

  const accounts = [];
  if (root instanceof Element && root.matches(accountSelector)) accounts.push(root);
  accounts.push(...root.querySelectorAll(accountSelector));
  accounts.forEach((account) => verifyAccount(account));
};

const queueActivationFallback = (account) => {
  const accountUrl = account.dataset.gohallAccountUrl;
  const startingUrl = window.location.href;
  if (!accountUrl) return;

  window.setTimeout(() => {
    if (!account.isConnected || window.location.href !== startingUrl || nativeInterfaceIsOpen(account)) return;
    window.location.assign(accountUrl);
  }, activationTimeout);
};

if (!window.gohallAccountFallbackControllerReady) {
  window.gohallAccountFallbackControllerReady = true;
  verifyAccounts();

  document.addEventListener('shopify:section:load', (event) => verifyAccounts(event.target));

  document.addEventListener('click', (event) => {
    const account = event.target instanceof Element ? event.target.closest(accountSelector) : null;
    if (!(account instanceof HTMLElement) || getWrapper(account)?.classList.contains(fallbackClass)) return;
    queueActivationFallback(account);
  });
}
